import enquire from 'enquire.js';
import breakpoints from '../breakpoints';

const NS = 'navToggle';
const activeModifier = 'is-nav-active';

const NavToggle = class {

    constructor() {
        this.$toggle = $('.js-nav-toggle');
        this.$header = $('.header');

        if (this.$toggle.length < 1) {
            return;
        }

        enquire.register(breakpoints.portable, {

            match: () => {
                this.$toggle.on(`click.${NS}`, () => {
                    this.handleToggle();
                });
            },

            unmatch: () => {
                this.$toggle.off(`click.${NS}`);
            },
        });

    }

    handleToggle() {
        this.$header.toggleClass(activeModifier);
    }

};

new NavToggle();
